// @ts-nocheck
import React from "react";

const Slash = React.memo(() => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="black"
            strokeWidth="0.5"
            strokeLinecap="square"
        >
            <line x1="0" y1="0" x2="25" y2="25"></line>
        </svg>
    );
});

export default Slash;
